( function ( $ ) {
	if ( $( '.header' ).length > 0 ) {
		const breakingPoint = $( '.header__top' ).outerHeight();
		function headerScroll() {
			if ( $( window ).scrollTop() > breakingPoint ) {
				$( 'body' ).addClass( 'scrolled' );
			} else {
				$( 'body' ).removeClass( 'scrolled' );
			}
		}
		headerScroll();
		$( window ).on( 'scroll', function () {
			headerScroll();
		} );
	}
} )( jQuery );
